/**
 * Preferências do mapa. Sobrevivem ao recarregamento porque escolher a camada é
 * gosto de quem opera, não estado da sessão — e reescolher a cada F5 irrita.
 *
 * `localStorage`, e não `sessionStorage` como o token: aqui não há nada
 * sensível, só a preferência visual.
 */
import { create } from "zustand";
import { DEFAULT_TILE_LAYER_ID, getTileLayer } from "../lib/tileLayers.ts";

const STORAGE_KEY = "mt.map.layer";

function readStoredLayerId(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    // Passa pelo `getTileLayer` para não restaurar um id que não existe mais.
    return stored ? getTileLayer(stored).id : DEFAULT_TILE_LAYER_ID;
  } catch {
    return DEFAULT_TILE_LAYER_ID;
  }
}

/**
 * As telas do painel.
 *
 * `report` saiu em 28/10: a tela existia, ninguém usava, e aba que não se usa
 * compete por espaço com as que se usam. **O endpoint `/devices/:imei/summary`
 * continua de pé** — a API não foi tocada, e `lib/report.ts` segue servindo o
 * filtro de período dos alertas.
 */
export type View = "map" | "consumption" | "alerts" | "operations" | "links" | "registry";

interface MapState {
  /** Tela em foco. Sem rota: o painel tem duas telas, e router aqui seria peso. */
  view: View;
  setView: (view: View) => void;

  tileLayerId: string;
  setTileLayer: (id: string) => void;
  /** Camada de via ruim. Desligada por padrão: ela polui o mapa operacional. */
  showRoadLayer: boolean;
  toggleRoadLayer: () => void;
  /** Cercas. LIGADAS por padrão: saber se o veículo saiu da área é operação. */
  showGeofences: boolean;
  toggleGeofences: () => void;
}

export const useMapStore = create<MapState>((set) => ({
  view: "map",
  setView: (view) => set({ view }),
  tileLayerId: readStoredLayerId(),
  showRoadLayer: false,
  toggleRoadLayer: () => set((state) => ({ showRoadLayer: !state.showRoadLayer })),
  showGeofences: true,
  toggleGeofences: () => set((state) => ({ showGeofences: !state.showGeofences })),
  setTileLayer: (id) => {
    try {
      localStorage.setItem(STORAGE_KEY, id);
    } catch {
      /* armazenamento bloqueado: a escolha só não sobrevive ao F5 */
    }
    set({ tileLayerId: id });
  },
}));
